// extracted by mini-css-extract-plugin
module.exports = {"bladeContentWrapper":"BladeContent_bladeContentWrapper__3pqIm","topFader":"BladeContent_topFader__2a53j","bladeContent":"BladeContent_bladeContent__2CHNu"};